import { equal } from '@ember/object/computed';
import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import espInfo, { EspInfo, EspKey, ESPS } from 'cio/utils/email-service-providers';
import { CampaignType } from './campaign';

export type AuthenticationType = 'none' | 'plain' | 'login' | 'cram_md5';

export type DefaultForType =
  | CampaignType.None
  | 'all'
  | CampaignType.Behavioral
  | CampaignType.Transactional
  | 'newsletter'
  | CampaignType.APITriggered
  | 'transactional_message';

export default class MailServerModel extends Model {
  @attr('string') address!: string;
  @attr('number') port!: number;
  @attr('string', { defaultValue: 'none' }) authentication!: AuthenticationType;
  @attr('string') username!: string;
  @attr('string') password!: string;
  @attr('string', { defaultValue: 'none' }) defaultFor!: DefaultForType;
  @attr('boolean', { defaultValue: false }) useApi!: boolean;

  @equal('authentication', 'none') unauthenticated!: boolean;
  @equal('password', null) passwordless!: boolean;
  @equal('defaultFor', 'all') isDefault!: boolean;
  @equal('address', 'smtp.sendgrid.net') providerIsSendgrid!: boolean;

  get selectedEsp(): EspKey | null {
    return (
      (Object.entries(ESPS) as [EspKey, EspInfo][]).find(([_, info]) => {
        if (typeof info.address === 'object' && info.address != null) {
          return Object.values(info.address).includes(this.address);
        }

        return info.address === this.address;
      })?.[0] ?? EspKey.Other
    );
  }

  get selectedEspInfo() {
    if (this.selectedEsp == null) {
      return null;
    }

    return espInfo(this.selectedEsp);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'mail-server': MailServerModel;
  }
}
